<script setup lang="ts">
import { computed } from 'vue';
import dayjs from 'dayjs';
import SlashCircleIcon from '@/assets/svg/slash-circle.svg?component';
import type { DoNotContactSummary } from '@/core/conversations/do-not-contact/do-not-contact.type';

const props = defineProps<{ summary: DoNotContactSummary; canUndo?: boolean }>();
defineEmits<{ (event: 'undo'): void }>();
const actor = computed(() =>
  [props.summary.createdBy?.nameFirst, props.summary.createdBy?.nameLast]
    .filter(Boolean)
    .join(' ')
    .trim(),
);
const date = computed(() =>
  props.summary.createTs && dayjs(props.summary.createTs).isValid()
    ? dayjs(props.summary.createTs).format('MMM D, YYYY')
    : '',
);
</script>

<template>
  <div
    data-test="do-not-contact-banner"
    class="flex shrink-0 items-center justify-center gap-4 bg-critical-50 px-4 py-2.5 text-xs font-bold leading-[18px] text-critical-600"
  >
    <div class="flex min-w-0 items-center gap-2">
      <SlashCircleIcon aria-hidden="true" class="h-5 w-5 shrink-0" />
      <p class="min-w-0 break-words">
        Marked Do Not Contact<span v-if="actor" class="font-normal"> by {{ actor }}</span
        ><span v-if="date" class="font-normal"> on {{ date }}</span>
      </p>
    </div>
    <button
      v-if="canUndo"
      type="button"
      data-test="do-not-contact-undo"
      class="min-h-11 min-w-11 shrink-0 uppercase sm:min-h-0 sm:min-w-0"
      @click="$emit('undo')"
    >
      Undo
    </button>
  </div>
</template>
